import baseAPI from '@/api/baseAPI'

class CourseTermsAPI extends baseAPI {
  get entity() {
    return {
      route: `/course_terms`,
      name: 'مادة في الفصل الدراسي'
    }
  }
}

export default new CourseTermsAPI()
